import { render, staticRenderFns } from "./LogoDark.vue?vue&type=template&id=ccb435d4&scoped=true&"
import script from "./LogoDark.vue?vue&type=script&lang=js&"
export * from "./LogoDark.vue?vue&type=script&lang=js&"
import style0 from "./LogoDark.vue?vue&type=style&index=0&id=ccb435d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb435d4",
  null
  
)

export default component.exports